import { PanelRightClose } from "lucide-react";
import { Button, Card, Select, Slider, Typography } from "@shared/ui";
import {
  DATE_RANGE_PRESETS,
  DateRangePreset,
  MAX_MAX_RESULTS,
  MIN_MAX_RESULTS,
} from "../lib/constants";
import styles from "./ExtractionSettings.module.scss";

const { Text } = Typography;

type ExtractionSettingsProps = {
  dateRangePreset: DateRangePreset;
  onDateRangePresetChange: (preset: DateRangePreset) => void;
  maxResults: number;
  onMaxResultsChange: (value: number) => void;
  onCollapse: () => void;
};

export function ExtractionSettings({
  dateRangePreset,
  onDateRangePresetChange,
  maxResults,
  onMaxResultsChange,
  onCollapse,
}: ExtractionSettingsProps) {
  return (
    <Card
      className={styles.settingsCard}
      title="Extraction Settings"
      extra={
        <Button
          type="text"
          icon={<PanelRightClose size={16} />}
          onClick={onCollapse}
          aria-label="Collapse extraction settings"
        />
      }
    >
      <div className={styles.field}>
        <Text className={styles.fieldLabel}>Select Posting Date Range</Text>
        <Select
          value={dateRangePreset}
          onChange={(value) => {
            const match = DATE_RANGE_PRESETS.find(
              (preset) => preset.value === value
            );
            if (match) {
              onDateRangePresetChange(match.value);
            }
          }}
          options={DATE_RANGE_PRESETS.map((preset) => ({
            value: preset.value,
            label: preset.label,
          }))}
          className={styles.fullWidth}
        />
      </div>

      <div className={styles.field}>
        <div className={styles.sliderHeader}>
          <Text className={styles.fieldLabel}>Max Results Per Keyword</Text>
          <Text className={styles.sliderValue}>{maxResults}</Text>
        </div>
        <Slider
          min={MIN_MAX_RESULTS}
          max={MAX_MAX_RESULTS}
          value={maxResults}
          onChange={(value) => {
            if (typeof value === "number") {
              onMaxResultsChange(value);
            }
          }}
        />
      </div>
    </Card>
  );
}
